// Shared control styling for the Client Groups surface, matching the v1 design
// (README §10): 34px controls, resting border #cbcbcb → active #9a9a9a, 8px
// radius, no Mantine focus ring. Applied to Select / NumberInput / TextInput /
// DateInput via the `styles` prop so the inputs read hi-fi rather than as
// Mantine defaults.
export const FIELD_HEIGHT = 34;

const inputBase = {
  minHeight: FIELD_HEIGHT,
  height: FIELD_HEIGHT,
  borderRadius: 8,
  borderColor: "var(--settings-border-strong)",
  fontSize: 13,
  "--input-bd-focus": "#9a9a9a" as any,
};

/** styles for Select / TextInput / DateInput / NumberInput. */
export const fieldStyles = {
  input: inputBase,
} as const;

/** A dashed pill button (`+ Add Condition`, `+ Filter`) per the design. */
export const dashedPill = {
  root: {
    height: 32,
    borderStyle: "dashed",
    borderColor: "#cfcfcf",
    borderRadius: 999,
    color: "var(--text-label, #555)",
    background: "transparent",
    fontSize: 12.5,
    fontWeight: 500,
  },
} as const;
